import api from "@/lib/api";

const audioUrlCache = new Map();
let activeAudio = null;

function stopActiveAudio() {
  if (activeAudio) {
    activeAudio.pause();
    activeAudio.currentTime = 0;
    activeAudio = null;
  }
}

function speakBrowser(text) {
  window.speechSynthesis.cancel();
  const utterance = new SpeechSynthesisUtterance(text);
  utterance.lang = "en-US";
  window.speechSynthesis.speak(utterance);
}

async function getOpenAIAudioUrl(text, model, voice) {
  const cacheKey = `${text}|${voice}|${model}`;
  let url = audioUrlCache.get(cacheKey);
  if (!url) {
    const response = await api.post("/tts/speak", { text, model, voice }, { responseType: "blob" });
    url = URL.createObjectURL(response.data);
    audioUrlCache.set(cacheKey, url);
  }
  return url;
}

export async function playTTS(text, settings) {
  if (!text) return;
  const provider = settings?.tts_provider || "browser";
  stopActiveAudio();

  if (provider !== "openai") {
    speakBrowser(text);
    return;
  }

  try {
    const url = await getOpenAIAudioUrl(text, settings?.tts_model, settings?.tts_voice);
    const audio = new Audio(url);
    activeAudio = audio;
    await audio.play();
  } catch (e) {
    speakBrowser(text);
  }
}

export async function previewTTS(text, model, voice) {
  stopActiveAudio();
  const url = await getOpenAIAudioUrl(text, model, voice);
  const audio = new Audio(url);
  activeAudio = audio;
  await audio.play();
}

export async function getTTSUrl(text, settings) {
  return getOpenAIAudioUrl(text, settings?.tts_model, settings?.tts_voice);
}

